// extracted by mini-css-extract-plugin
export var buttonContainer = "ButtonPanel-module--buttonContainer--XuPFW";
export var cyan = "ButtonPanel-module--cyan--HxgEj";
export var orange = "ButtonPanel-module--orange--qH-aq";
export var pink = "ButtonPanel-module--pink--Se3Za";
export var purple = "ButtonPanel-module--purple--AxWJZ";
export var red = "ButtonPanel-module--red--2ThvJ";
export var root = "ButtonPanel-module--root--4i7eU";
export var smallWrap = "ButtonPanel-module--smallWrap--ShjcP";